module.exports = __webpack_public_path__ + "img/team.3e51300d.svg";